import React, {Component} from "react";
import Table from "../../components/Table";
import MetaAggregatedOrderItem from "./MetaAggregatedOrderItem";
import GraphQLErrors from "../../components/GraphQLErrors";
import {fromJS} from "immutable";
import {graphql} from "react-apollo";
import {LIST_META_ORDERS} from "../../queries/sales";
import PaginatorButton from "../../components/PaginatorButton";
import withFiltersAndSorting, {SORTING_DIRECTIONS} from "../../lib/WithFiltersAndSorting";

class MetaOrderList extends Component {

  render() {
    const {loading, error, salesMetaOrders} = this.props.data;

    if (error) return <GraphQLErrors error={error} />

    let entries = salesMetaOrders?.entries || [];
    if (this.props.metaOrderId) {
      entries = entries.filter((order) => order.metaOrderId === this.props.metaOrderId);
    }

    return (
      <div>
        <Table
          loading={loading}
          data={fromJS(entries)}
          renderer={(props) => <MetaAggregatedOrderItem {...props} advancedMode={this.props.advancedMode} />}
          tableHeader={this.props.tableColumns}
          createSortingArrows={this.props.createSortingArrows}
          onItemClick={this.handleItemClick.bind(this)}
          extraClassName="OrderList"
          itemKey="metaOrderId"
          mode="table"
          selected={this.props.selectedId}
          showCount={true}
          />
        <PaginatorButton
          metadata={fromJS(salesMetaOrders?.metadata)}
          onNext={this.handleNext.bind(this)}
          />
      </div>
    );
  }

  handleNext(afterId) {
    this.props.data.fetchMore({
      variables: {
        pagination: {
          after: afterId
        }
      },
      updateQuery: (prev, {fetchMoreResult}) => {
        if (!fetchMoreResult) return prev;
        return {
          salesOrders: {
            __typename: prev.salesOrders.__typename,
            metadata: fetchMoreResult.salesOrders.metadata,
            entries: [...prev.salesOrders.entries, ...fetchMoreResult.salesOrders.entries]
          }
        }
      }
    })
  }

  handleItemClick(itemData, e, field = "") {
    let id = itemData.get("metaOrderId");
    if (field === "id") {
      e.stopPropagation();
      this.props.onIdClick(id);
      return;
    }
    this.props.onSelectionChange(id);
  }
}


const withQuery = graphql(LIST_META_ORDERS, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      filter: {
        ...props.filters,
      },
      sortOrders: props.sortOrders,
    }
  })
})

export default withFiltersAndSorting(withQuery(MetaOrderList), {
  tableColumns: (props) => {
    const columns = [
      { title: "Meta Order #" },
      { title: "Shop Id" },
      { title: "State" },
      { title: "Client Name" },
      { title: "Shipping Order Ids"},
      { title: "Created at" },
      { title: "Last updated at" },
      { title: "Source" },
    ];

    return columns;
  },
  defaultSortings: [{name: "created_at", direction: SORTING_DIRECTIONS.DESC}, {name: "meta_order_id", direction: SORTING_DIRECTIONS.ASC}],
})
